import { useFlags } from "features/api/flags"

export function useIsAstroLoyaltyEnabled(): boolean {
  const { ENABLE_ASTRO_LOYALTY } = useFlags()
  return ENABLE_ASTRO_LOYALTY.boolVal
}
